import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .component_line_canvas {
    height: 120px;
    width: 70%;
    margin: 20px auto;
  }
  .component_line_canvas_text {
    margin-top: 24px;
    text-align: center;
    > div:first-child {
      margin-bottom: 12px;
      color: ${color.green1};
    }
    > div:last-child {
      color: ${color.black2};
      display: inline-flex;
      justify-content: center;
      column-gap: 4px;
    }
  }
`;

export default Wrapper;
